import types from './types';
import { SAVE_INVENTORY_OR_OPEN_CONFIRMATION_MODAL_SUCCESS } from '../inventories/types';
import { SAVE_CHEMICAL_PRODUCT_OR_OPEN_CONFIRMATION_MODAL_SUCCESS } from '../chemicalProducts/types';

const defaultState = {
  open: false
};

export default (
  state = defaultState,
  {
    type,
    params,
    request /* using takeQuery: the initier action is set here */,
    data /* using takeQuery: query result will be set here */,
    ...action
  }
) => {
  switch (type) {
    case types.TOGGLE_SAVE_INVENTORY_MODAL:
      return {
        ...state,
        open: action.state,
        processedChangesNotification: null
      };

    case types.UPDATE_PROCESSED_CHANGES_NOTIFICATION:
      return {
        ...state,
        processedChangesNotification: action.processedChangesNotification,
        recipients: action.recipients,
        isLoading: true
      };
    case types.SET_MARK_AS_CHECKED:
      return {
        ...state,
        markAsChecked: action.markAsChecked
      };

    case SAVE_INVENTORY_OR_OPEN_CONFIRMATION_MODAL_SUCCESS:
    case SAVE_CHEMICAL_PRODUCT_OR_OPEN_CONFIRMATION_MODAL_SUCCESS:
      return {
        ...state,
        open: data.openConfirmationModal,
        isLoading: !data.openConfirmationModal,
        processedChangesNotification: data.processedTemplateBody,
        recipients: data.recipients
      };

    default:
      return state;
  }
};
